export const percsTriptych = [
  {
    title: `Your schedule,
  your savings`,
    paragraph:
      'You decide how often you want each personalized product in your routine delivered. Shampoo every 4 weeks and skincare every 8? Done. Plus, enjoy 15% off + free shipping on every order.',
  },
  {
    title: `Snooze, adjust,
  or cancel anytime`,
    paragraph:
      'Heading out of town or not ready for a refill? You can pause deliveries for up to 90 days or make changes to your subscription with just a few clicks.',
  },
  {
    title: `Formulas that
  evolve with you`,
    paragraph: (
      <>
        {'It only gets better. With Review & Refine'}
        <sup>{'®'}</sup>
        {
          ', we’ll address any new concerns, fine-tune your formulas with the seasons, and learn from your feedback for always-improving results.'
        }
      </>
    ),
  },
];

export const percentOff = {
  title: `Save on
  every order`,
  paragraph:
    'When you subscribe to haircare and skincare, you’ll enjoy the same exclusive perks across both subscriptions, including 15% off every future order.',
};

export const flexibility = {
  title: `Free shipping,
  always`,
  paragraph: 'Plus hassle-free returns. Cancel, change, or snooze your plan any time.',
};
